module.exports = __webpack_public_path__ + "static/img/hfb.afaf624.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hfb.png
// module id = fJ2g
// module chunks = 24